import { MapPin, Plus } from '@ufc/uikit'
import { TableEmptyState } from '@ufc/uikit'
import type { AddressbookEmptyStateProps } from '../types'

export function AddressbookEmptyState({
  title,
  description,
  actionLabel,
  onAction,
}: AddressbookEmptyStateProps) {
  return (
    <div className="glass-card rounded-2xl overflow-hidden">
      <TableEmptyState
        icon={MapPin}
        title={title}
        description={description}
        actionLabel={actionLabel}
        actionIcon={Plus}
        onAction={onAction}
      />
    </div>
  )
}
